/**
 * Icon with a tooltip
 */

import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TooltipIconConfig } from '@shared/types/entities/base';
import { get } from 'lodash';

// eslint-disable-line @angular-eslint/prefer-on-push-component-change-detection
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xux-tooltip-icon',
  templateUrl: './xux-tooltip-icon.component.html',
  styleUrls: ['./xux-tooltip-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class XuxTooltipIconComponent implements OnInit {
  @Input() public config: TooltipIconConfig;
  @Input() public isOpen: boolean = false;

  public icon: string;
  public tooltip: string;
  public placement: string;
  public container: string;
  public containerClass: string;
  public class: string;
  public template: string;

  public constructor(private sanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    this.icon = get(this.config, 'icon', 'icon-info');
    this.tooltip = get(this.config, 'tooltipConfig.tooltip', null);
    this.placement = get(this.config, 'tooltipConfig.placement', 'right');
    this.placement = get(this.config, 'tooltipConfig.placement', 'right');
    this.container = get(this.config, 'tooltipConfig.container', 'body');
    this.containerClass = get(
      this.config,
      'tooltipConfig.containerClass',
      'xux-hint-pre-line',
    );
    this.class = get(this.config, 'class', 'black');
    this.template = get(this.config, 'tooltipConfig.template', null);
  }

  public sanitizeHTMLStringValue(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
